import * as evaluation from "./evaluation";

export function createContext(template: ITemplate, parameters) {
    const context = {};
    Object.assign(context, template.defaults);
    Object.assign(context, parameters);
    Object.assign(context, evaluation.evaluateExpressionMap(template.locals, context));
    return context;
}
